import {StatisticsPieChart} from './StatisticsPieChart';
export default StatisticsPieChart;
